import Vue from 'vue'
import VueCookies from 'vue-cookies'
import api from '../../api/leadRealAPI'
import router from '../../router'

Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    allAdmin: {},
    adminData: null,
    deleteMsg: null,
    permission: {}
  },

  getters: {
    allAdmin: state => state.allAdmin,
    adminData: state => state.adminData,
    deleteMsg: state => state.deleteMsg,
    permission: state => state.permission
  },

  mutations: {
    setAllAdmin (state, allAdmin) {
      state.allAdmin = allAdmin
    },
    setAdminData (state, adminData) {
      state.adminData = adminData
    },
    setPermission (state, permission) {
      state.permission = permission
    },
    setDeleteMsg (state, deleteMsg) {
      state.deleteMsg = deleteMsg
    }
  },

  actions: {
    getPermission ({ commit }) {
      api
        .get('admin/permissionAccount')
        .then(response => {
          commit('setPermission', response.data)
        })
        .catch(() => {})
    },
    getAllAdmin ({ commit }) {
      api
        .get('admin/adminList')
        .then(response => {
          commit('setAllAdmin', response.data)
        })
        .catch(() => {})
    },
    registerAdmin ({ commit, dispatch }, data) {
      api
        .post('admin/registrationAdministrator', data)
        .then(response => {
          if (response.data.errors) {
            dispatch('getErrors', response.data.errors, { root: true })
          } else {
            commit('setApiStatus', response.data.status, { root: true })
            setTimeout(() => commit('setApiStatus', null, { root: true }), 3000)
            dispatch('getErrors', null, { root: true })
          }
        })
        .catch(() => {})
    },
    getAdmin ({ commit }, data) {
      commit('setAdminData', null)
      api
        .get('admin/adminSpecific/' + data)
        .then(response => {
          commit('setApiStatus', null, { root: true })
          commit('setAdminData', response.data.listAdmin[0])
        })
        .catch(() => {})
    },
    deleteAdmin ({ commit }, data) {
      api
        .post('admin/deleteAdministrator/' + data)
        .then(response => {
          commit('setDeleteMsg', response.data.status)
          setTimeout(() => commit('setDeleteMsg', null), 3000)
          router.push({ name: 'List of Administrators' })
        })
        .catch(() => {})
    },
    updateAdmin ({ commit, state }, data) {
      api
        .post('admin/updateAdministrator/' + state.adminData.id, data)
        .then(response => {
          commit('setApiStatus', response.data, { root: true })
          setTimeout(() => commit('setApiStatus', null, { root: true }), 3000)
        })
        .catch(() => {})
    }
  }
}
